export enum Dependencies {
  REQUEST = 'request',
  METRICS = 'metrics',
}
